import { render, staticRenderFns } from "./SimpleDialog.vue?vue&type=template&id=089bcf1c&"
import script from "./SimpleDialog.vue?vue&type=script&lang=ts&"
export * from "./SimpleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports